
window.initRelatedSwatches = function () {
    // Destroy previous swiper instances to avoid conflicts on re-init
    if (window.__relatedSwipers) {
        window.__relatedSwipers.forEach(function (s) { if (s && s.destroy) s.destroy(true, true); });
    }
    window.__relatedSwipers = [];

    var colorSwatches = document.querySelectorAll('.related-product-quickview-variant_color');
    var sizeSwatches = document.querySelectorAll('.related-product-quickview-variant_size');

    SwatchesOptions(colorSwatches);
    SwatchesOptions(sizeSwatches);

    function SwatchesOptions(option) {
        option.forEach(function (swatch) {
            swatch.addEventListener('click', function (event) {
                event.preventDefault();

                let __product = JSON.parse(event.target.closest('.card-related-product').getAttribute('data-product'));
                // Obtener el valor del color/talla seleccionado

                let selectValue = this.getAttribute('value');
                let selectedOption = this.getAttribute('option-selected');
                let selectElement = this.closest('.related-product-quickview-form').querySelector('.related-product-quickview-form__variants');

                updateSelectedVariant(selectElement, selectValue, selectedOption, __product, event);


                if (selectedOption === 'Color') {
                    const sizeSwatchesT = this.closest('.related-product-quickview-form').querySelector('.related-product-quickview-size').querySelectorAll('.swatch-btn');
                    availableVariant(selectValue, sizeSwatchesT, __product);
                }

                const optionSwatches = this.closest('.related-product-quickview-swatch').querySelectorAll('.swatch-btn');
                optionSwatches.forEach(swatchH => {
                    swatchH.closest('.related-swatch-container').classList.remove('selected-swatch-container');
                    swatchH.classList.remove('selected');
                });

                event.target.closest('.related-swatch-container').classList.add('selected-swatch-container');
                event.target.classList.add('selected');

            });
        });
    }

    function updateSelectedVariant(selectEl, optionValue, selectedOption, __product, event) {
        let addToCartQuick = event.target.closest('.card-related-product').querySelector('.related-product-quickview-add-to-cart-btn');

        let selectedValue = selectEl.options[selectEl.selectedIndex].dataset.variantOptions;
        let colorDef = selectedValue.split('-')[0];
        let sizeDef = selectedValue.split('-')[1];
        const relatedProductContainer = event.target.closest('.card-related-product').querySelector('.card-related-product__price');

        if (selectedOption === 'Size') sizeDef = optionValue;

        if (selectedOption === 'Color') {
            colorDef = optionValue;
            const relatedProductType = event.target.closest('.card-related-product').getAttribute('data-cart-type');
            if (relatedProductType === 'image') {

                changeColorImageVariant(selectedOption, colorDef, selectEl, event)

            } else {
                changeCarouselColor(selectedOption, colorDef, selectEl, event)
            }
        }

        let matchText = `${colorDef}-${sizeDef}`;
        let matchedOption = Array.from(selectEl.options).filter(option => option.dataset.variantOptions === matchText);


        if (matchedOption[0] !== undefined) {
            selectEl.value = matchedOption[0].getAttribute('value');
            let { available, price, compare_at_price, id } = getProductVariantAvailability(__product, matchedOption[0].value)[0];
            updateProducPrice(price, compare_at_price, id, relatedProductContainer)

            if (!available) addToCartQuick.classList.add('dn-i');
            if (available) addToCartQuick.classList.remove('dn-i');
        }

        else console.log('OPTION SOLD OUT');

    }


    function getProductVariantAvailability(product, variantId) {
        const _productVariant = product.variants;
        const availableProduct = _productVariant.filter(availableVariant => availableVariant.id === parseInt(variantId));
        return availableProduct
    }
    function updateProducPrice(variantPrice, variantCAPrice, variantId, cardContainer) {
        const productCAPrices = cardContainer.querySelectorAll(`.card-related-product__price-compare-at-price`);
        const productSelectedCAPrice = cardContainer.querySelector(`.compare-at-price-${variantId}`);

        const productPrices = cardContainer.querySelectorAll(`.card-related-product__price`);
        const productSelectedPrice = cardContainer.querySelector(`.variant-price-${variantId}`)

        if (variantPrice > 0 && productPrices) {
            productPrices.forEach(prd => prd.classList.add('dn-i'));
            productSelectedPrice && productSelectedPrice.classList.toggle('dn-i')
        }


        if (variantCAPrice > 0 && productCAPrices) {
            productCAPrices.forEach(prd => prd.classList.add('dn-i'));
            productSelectedCAPrice && productSelectedCAPrice.classList.toggle('dn-i');

        }


    }

    function availableVariant(color, sizeSwatchesTarget, product) {
        const _productVariant = product.variants;

        let colorVariants = _productVariant.filter(variant => {
            let variantOption1 = variant.option1.replace(/\s+/g, ':').toLowerCase();
            return variantOption1 === color;
        });


        let availableSizes = colorVariants.filter(variant => variant.available == false).map(variant => variant.option2.replace(/\s+/g, ':').toLowerCase());


        sizeSwatchesTarget.forEach(function (sizeSwatch) {

            let size = sizeSwatch.getAttribute('value').replace(/\s+/g, ':').toLowerCase();

            sizeSwatch.classList.remove('sold-out-related');

            if (availableSizes.includes(size)) return sizeSwatch.classList.add('sold-out-related');


        });

    }

    function changeColorImageVariant(selectOption, colorSelected, element, event) {
        const colorClean = colorSelected.replaceAll(':', '-');
        let articleParent = element.closest('.card-related-product');
        let ImagesbyColor = articleParent.querySelectorAll('.card-related-product__media--image');

        if (selectOption === "Color") {

            const imageByColor = [...ImagesbyColor].filter((image) => {
                image.classList.add('dn-i')
                return image.getAttribute('alt').includes(colorClean);
            });

            if (articleParent.getAttribute('data-cart-type') == "image") {

                if (imageByColor.length > 0) return imageByColor.shift().classList.remove('dn-i');
                return console.log('No Images Avaibles')
            }



        } else {
            console.log('No color Selected')
        }

    }

    function changeCarouselColor(selectOption, colorSelected, element, event) {
        const colorClean = colorSelected.replaceAll(':', '-');
        let articleParent = element.closest('.card-related-product');


        if (selectOption === "Color") {

            [...articleParent.querySelectorAll('.related-product-images--group')].forEach((divPa) => {


                divPa.classList.remove('related-slide-active');
                divPa.classList.add('hide-slide')

                if (divPa.getAttribute('data-color-select').includes(colorClean)) {

                    divPa.classList.remove('hide-slide');
                    divPa.classList.add('related-slide-active');

                }

            });


        } else {
            console.log('No color Selected')
        }

    }




    function quickAddShowModule() {
        //add the text to made clickable to show module .related-product-quickview-button
        const quickAddButtons = document.querySelectorAll('.button-quickadd-action');

        quickAddButtons.forEach((quickAddButton) => {

            quickAddButton.addEventListener('click', (event) => {
                const buttonQuick = event.target;
                const relatedContainer = buttonQuick.closest('.card-related-product');
                const relatedQuickAddComponents = relatedContainer.querySelectorAll('.quickadd-component');
                //add absolute class of the buttons swatches
                const buttonsSwatches = relatedContainer.querySelector('.card-related-quickview-swatches')

                buttonsSwatches.classList.toggle('absolute-i')

                relatedQuickAddComponents.forEach(component => {

                    if (component.classList.contains('current-component-show')) {

                        component.classList.remove('current-component-show');
                        component.classList.add('current-component-hide');
                    } else if (component.classList.contains('current-component-hide')) {

                        component.classList.remove('current-component-hide');
                        component.classList.add('current-component-show');
                    }
                });

            })

        })
    }

    async function addToCartQuickView(event) {
        event.preventDefault();
        const bodyEleV = document.querySelector('body');
        const drawerCartV = document.querySelector('#drawer-cart-modal')
        const quickViewForm = event.target.closest('.related-product-quickview-form');

        const formDataV = new FormData(quickViewForm);

        try {
            const responseV = await fetch('/cart/add.js', {
                method: 'POST',
                body: formDataV
            });
            await responseV.json();

            bodyEleV.style.overflow = 'hidden';
            drawerCartV.classList.add('show-cart-modal');
            liquidAjaxCart.update();

        } catch (error) {
            console.log(error);
        }

    }

    quickAddShowModule();

    let addToCartButtons = document.querySelectorAll('.related-product-quickview-add-to-cart-btn');
    addToCartButtons.forEach((addToCartBtnS) => addToCartBtnS.addEventListener('click', addToCartQuickView));


    function swiperRelatedProducts() {
        var swiper1 = new Swiper('.related-products_swiper', {
            slidesPerView: 'auto',
            spaceBetween: 15,
            loop: false,
            allowTouchMove: true,
            navigation: {
                nextEl: '.swiper-button-next-gl',
                prevEl: '.swiper-button-prev-gl',
            },
        });

        var swiper2 = new Swiper('.related-products-alsolike_swiper', {
            slidesPerView: 'auto',
            spaceBetween: 15,
            loop: false,
            allowTouchMove: true,
            navigation: {
                nextEl: '.swiper-button-next-alsolike',
                prevEl: '.swiper-button-prev-alsolike',
            },
        });

        window.__relatedSwipers.push(swiper1, swiper2);
    }

    swiperRelatedProducts();

};